class DreambabyGiftlist {
  constructor() {
    this.giftlistButton = document.querySelector('.add-to-giftlist-button');
    this.modal = document.getElementById('giftlist-success-modal');

    if (this.giftlistButton) {
        try {
            this.variantMetafields = JSON.parse(this.giftlistButton.getAttribute('data-variants') || '{}');
        } catch (e) {
            this.variantMetafields = {};
       }
      this.giftlistApiUrl = this.giftlistButton.getAttribute('data-has-giftlist-url');
      this.addProductToGiftlistApiUrl = this.giftlistButton.getAttribute('data-add-product-to-giftlist-url');
      this.giftlistUrl = this.giftlistButton.getAttribute('data-giftlist-path');
      this.articleType = this.giftlistButton.getAttribute('data-article-type');
      this.init();
      // MSYDB-667 - Disable features, keep bugfixes
      //subscribe(PUB_SUB_EVENTS.variantChange, this.updateButtonVisibility.bind(this));
    }

    if (!this.modal) {
      return;
    }
    document.body.appendChild(this.modal);
  }

  init() {
    this.checkGiftlistStatus();

    this.giftlistButton.addEventListener('click', (event) =>  {
      if(this.giftlistButton.dataset.customerHasGiftlist === 'false') {
         this.setModalToStartGiftlist();
        this.showModal()
        return;
      }
      this.handleAddToGiftlist(event);
    });

    if (!this.modal) {
      return;
    }

    this.modal.querySelector('[data-action="go-to-giftlist"]').addEventListener('click', () => {
        if(this.giftlistButton.dataset.customerHasGiftlist === 'false') {
          window.location.href = this.giftlistButton.getAttribute('data-start-giftlist-modal-confirm-button-href');
        }
        else{
          window.location.href = this.giftlistUrl;
        }
    });

    this.modal.querySelector('[data-action="continue-shopping"]').addEventListener('click', () => {
      this.hideModal();
    });

    this.modal.addEventListener('click', (event) => {
      const modalContent = this.modal.querySelector('.dreambaby-giftlist-success-modal__content');
      if (modalContent && !modalContent.contains(event.target)) {
        this.hideModal();
      }
    });
  }

  updateButtonVisibility() {
      if(shouldHideVariant(this.variantMetafields[this.giftlistButton.getAttribute('data-product-id')], this.articleType)) {
          this.giftlistButton.classList.remove('is-visible');
          return;
      }
      this.giftlistButton.classList.add('is-visible');
  }

  async checkGiftlistStatus() {
    try {
      const isCustomerLoggedIn = this.giftlistButton.getAttribute('data-customer-logged-in') !== '';
      if (!isCustomerLoggedIn) {
        this.giftlistButton.classList.add('is-visible');
        return;
      }
      const response = await fetch(this.giftlistApiUrl);

      if (!response.ok) {
        throw new Error('Failed to fetch giftlist status');
      }

      const data = await response.json();

      if (!data.hasGiftlist) {
       // return;
      }
      this.giftlistButton.setAttribute('data-customer-has-giftlist', data.hasGiftlist);

      // MSYDB-667 - Disable features, keep bugfixes
      /*if (shouldHideVariant(this.variantMetafields[this.giftlistButton.getAttribute('data-product-id')], this.articleType)) {
          return;
      }*/

      this.giftlistButton.classList.add('is-visible');
    } catch (error) {
      console.error('Error checking giftlist status:', error);
    }
  }

  handleAddToGiftlist(event) {
    event.preventDefault();

    const productId = this.giftlistButton.getAttribute('data-product-id');
    const productSku = this.giftlistButton.getAttribute('data-product-sku');
    const productName = this.giftlistButton.getAttribute('data-product-name');
    const quantitySelector = document.querySelector('.quantity__input');
    const quantity = quantitySelector ? quantitySelector.value : 1;

    if (!productId || !productSku) {
      console.error('Product ID or SKU missing');
      return;
    }

    this.addProductToGiftlist(productId, productSku, productName, quantity);
  }

  async addProductToGiftlist(productId, productSku, productName, quantity) {
    try {
      this.giftlistButton.classList.add('loading');
      this.giftlistButton.disabled = true;

      const response = await fetch(this.addProductToGiftlistApiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          productId,
          productSku,
          productName,
          quantity
        })
      });

      if (response.redirected) {
        throw new Error('User not authenticated');
      }

      if (!response.ok) {
        throw new Error('Failed to add product to giftlist');
      }

      if (!this.modal) {
        throw new Error('Could not find modal');
      }

      this.showModal();

      const isProductPage = document.body.classList.contains('page-product') || window.location.pathname.includes('/products/');

      if (!isProductPage) {
        const successMessage = this.giftlistButton.getAttribute('data-success-message');
        if (successMessage && typeof window.DreambabyNotificationHandler?.showNotification === 'function') {
          window.DreambabyNotificationHandler.showNotification(successMessage, 'success');
        }
      }
    } catch (error) {
      console.error('Error adding product to giftlist:', error);
      const errorMessage = this.giftlistButton.getAttribute('data-error-message');
      if (typeof window.DreambabyNotificationHandler?.showNotification === 'function') {
        window.DreambabyNotificationHandler.showNotification(errorMessage, 'error');
      }
    } finally {
      this.giftlistButton.classList.remove('loading');
      this.giftlistButton.disabled = false;
    }
  }

  setModalToStartGiftlist() {
    if(!this.modal){
      return;
    }
    this.modal.querySelector('.dreambaby-giftlist-success-modal__title').textContent = this.giftlistButton.getAttribute('data-start-giftlist-modal-title');
    this.modal.querySelector('.dreambaby-giftlist-success-modal__body').innerHTML = this.giftlistButton.getAttribute('data-start-giftlist-modal-message');
    this.modal.querySelector('.button.button--primary').textContent = this.giftlistButton.getAttribute('data-start-giftlist-modal-confirm-button-text');

  }

  showModal() {
    if (!this.modal) {
      return;
    }
    this.modal.style.display = 'block';
    document.body.classList.add('dreambaby-giftlist-success-modal-open');
  }

  hideModal() {
    if (!this.modal) {
      return;
    }
    this.modal.style.display = 'none';
    document.body.classList.remove('dreambaby-giftlist-success-modal-open');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new DreambabyGiftlist();
});
